(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-dostawa-premium"] && !Shopify.designMode) return;
  try {
    
(function() {
  function updateSummaryState(item) {
    var summary = item.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
    }
  }

  document.querySelectorAll('.delivery-faq__item').forEach(function(item) {
    updateSummaryState(item);
    item.addEventListener('toggle', function() {
      updateSummaryState(item);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
